import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SetPasswordGuard } from '@kp/auth/guards/set-password.guard';
import { DialogueSignupComponent } from '@kp/dialogue/components/dialogue-signup/dialogue-signup.component';
import { DialogueInformationComponent } from '@kp/dialogue/dialogue-information/dialogue-information.component';
import { DialogueStatusComponent } from '@kp/dialogue/dialogue-status/dialogue-status.component';
import { DialogueComponent } from '@kp/dialogue/dialogue.component';
import { AnswerComponent } from '@kp/question-set/answer/answer.component';
import { CheckboxListComponent } from '@kp/question-set/answer/checkbox-list/checkbox-list.component';
import { DiamondLikertComponent } from '@kp/question-set/answer/diamond-likert/diamond-likert.component';
import { RadioButtonComponent } from '@kp/question-set/answer/radio-button/radio-button.component';
import { SliderComponent } from '@kp/question-set/answer/slider/slider.component';
import { ImageIconComponent } from '@kp/question-set/answer/word-list/image-icon/image-icon.component';
import { WordListComponent } from '@kp/question-set/answer/word-list/word-list.component';
import { QuestionComponent } from '@kp/question-set/question/question.component';
import { SingleQuestionComponent } from '@kp/question-set/single-question/single-question.component';
import { OnboardingDialogueAvailableGuard } from '@kp/shared/guards/onboarding-dialogue-available.guard';

const routes: Routes = [
  { path: '', component: DialogueComponent, canActivate: [SetPasswordGuard] },
  {
    path: 'onboarding',
    component: DialogueStatusComponent,
    canActivate: [SetPasswordGuard, OnboardingDialogueAvailableGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DialogueRoutingModule {
  static components = [
    AnswerComponent,
    CheckboxListComponent,
    DialogueComponent,
    DialogueInformationComponent,
    DialogueSignupComponent,
    DialogueStatusComponent,
    DiamondLikertComponent,
    ImageIconComponent,
    QuestionComponent,
    RadioButtonComponent,
    SingleQuestionComponent,
    SliderComponent,
    WordListComponent,
  ];
}
